const $ = jQuery.noConflict();
import 'select2/dist/js/select2.full.js';

'use strict';
const Select2 = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$select: $('.js-select'),
	$selectServices: $('.js-select-services'),

	/** @description Initialize */
	init: function() {
		this.select2();
		// disable mousewheel on a input number field when in focus
		$('form').on('focus', 'input[type=number]', function(e) {
			$(this).on('wheel.disableScroll', function(e) {
				e.preventDefault();
			});
		});
		$('form').on('blur', 'input[type=number]', function(e) {
			$(this).off('wheel.disableScroll');
		});
		// condition field
		$('.num-people input').addClass('number-of-people');
		$('.contact-from__wrap--hidden').removeClass('option-is-selected');
		if ($('.js-select-services').val() === 'Headshots') {
			$('.contact-from__wrap--hidden').addClass('option-is-selected');
			$('.js-conditional-fields').addClass('more-options');
		} else {
			$('.contact-from__wrap--hidden').removeClass('option-is-selected');
			$('.js-conditional-fields').removeClass('more-options');
		}
		$('.js-select-services').on('change', function() {
			if ($(this).val() === 'Headshots') {
				$('.contact-from__wrap--hidden').addClass('option-is-selected');
				$('.js-conditional-fields').addClass('more-options');
			} else {
				$('.contact-from__wrap--hidden').removeClass('option-is-selected');
				$('.js-conditional-fields').removeClass('more-options');
			}
		});
	},

	select2: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$select.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class'
		});
		Select2.$selectServices.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'select-services'
		});
	}
};

export default Select2;
